module.exports = __webpack_public_path__ + "img/icon-sh.fac0a553.png";